var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('children-route',{attrs:{"animate":false,"animateKey":_vm.$route.params.contentmanager_id}})}
var staticRenderFns = []

export { render, staticRenderFns }